import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import PropTypes from 'prop-types';
import React from 'react';
import SimplifiedIntermediateHighSchoolResults from './simplified-intermediate-highschool-results';
import { loadMorePaginationProp, SimpleLoadingComponent } from '../../utils/apollo';

class SimpleSearchResultsComponent extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    loadMore: PropTypes.func,
  };

  render() {
    return (
      <SimplifiedIntermediateHighSchoolResults
        {...this.props}
        queryName="simplifiedIntermediateHighSchoolSearch"
        resultsTitle="Results"
      />
    );
  }
}

const query = gql`
  query SimplifiedIntermediateHighSchoolResults($first: Int, $after: String,
    $fromDate: OrdinalDate, $filters: [RepVisitsFilter!]) {
    viewer {
      id
      enabledFeatures
      simplifiedIntermediateHighSchoolSearch(first: $first, after: $after, fromDate: $fromDate, filters: $filters) {
        edges {
          node {
            id
            name
            interestedStudents
            repVisitsAccount {
              id
              availabilityVisible
            }
            address {
              field_hs_elna_state_latest
              field_hs_elna_city
              field_hs_eln_zip
              field_hs_el_county_name
              field_hs_na_country_name
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    }
  }`;

const graphqlData = graphql(query, {
  options: ({ params }) => ({
    variables: {
      first: 25,
      filters: params.map((param) => ({
        searchType: param.searchType,
        filter: param.filter,
      })),
      fromDate: params[0].fromDate,
    },
  }),
  props: loadMorePaginationProp(query),
});
export default SimpleLoadingComponent(graphqlData)(SimpleSearchResultsComponent);
